import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keys'})
export class KeysPipe implements PipeTransform {
  transform(value, args:string) : any {
    let valType = args; 
    let objKey = Object.keys(value);
    return valType == 'key' ? objKey[0] : value[objKey[0]]
  }
}